import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  credits: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.loading = false;
    },
    logoutUser: (state) => {
      state.user = null;
      state.credits = null;
    },
    setCredits: (state, action) => {
      state.credits = action.payload;
    },
    updateCredits: (state, action) => {
      // Increment/decrement credits (action.payload can be positive or negative)
      if (state.credits !== null) {
        state.credits += action.payload;
      }
    },
     clearUser: (state) => {   // ✅ add this if missing
    state.user = null;
  }
  },
});

export const { setUser, logoutUser, setCredits, updateCredits, clearUser } = userSlice.actions;
export default userSlice.reducer;